const Stat = () => import('@/pages/data/stat/index.vue');

export default [{
    path: '/data/stat',
    component: Stat,
    meta: [{
        name: '数据管理',
		activeRoute: '/data/manage'
    },
    {
        name: '数据分析',
        activeRoute: '/data/stat'
    }]
}];